import React from "react";

const StyledCodeEmployee = ({ row }) => {
  return <div>{row?.employee?.employeeCode}</div>;
};

export default StyledCodeEmployee;
